export enum PaymentType {
    "Te Gjitha",
    Wallet,
    CreditCard
}
